export const ErrorStatus = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  CREDIT_CHECK_FAILED: 'CREDIT_CHECK_FAILED',
} as const;
